export const iconFontAwesomeFilesFileVideo = (
	<i className="fa-solid fa-file-video"></i>
);
